// extracted by mini-css-extract-plugin
export default {"container":"NamedItemComponent_container__30HSt","label":"NamedItemComponent_label__jCK6r","content":"NamedItemComponent_content__eJcP7"};